import { render, staticRenderFns } from "./BsiContinuousFilingFilesDetails.vue?vue&type=template&id=27e99ff3&scoped=true&"
import script from "./BsiContinuousFilingFilesDetails.vue?vue&type=script&lang=js&"
export * from "./BsiContinuousFilingFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./BsiContinuousFilingFilesDetails.vue?vue&type=style&index=0&id=27e99ff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e99ff3",
  null
  
)

export default component.exports